import {
  Box,
  Center,
  Flex,
  Text,
  Link,
} from "@chakra-ui/react";
import SectionHeading from "./sectionHeading";
import Lang from "../../Lang";
import LineSection from "../lineSection";

export default function Apply() {
  return (
    <Box
      color={"white"}
    >
      <LineSection />
      <Center>
        <Box
          w={{ base: "full", md: "4xl", xl: "4xl" }}
        >
          <Flex
            alignItems={"center"}
            h={"100%"}
          >
            <Box
            pt={20}
            >
              <SectionHeading
                title="Apply"
              />
              <Text
                w={{ base: "full", md: "3xl", xl: "4xl" }}
                pt={10}
                pb={{base:40,md:60}}
                px={{ base: 4, md: 6 }}
                fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
                >
                <Lang text="If you are a professor that led a group of students and do activities related to robotics, 3D prints, programming or similar, go to" /> &nbsp;
                <Link
                  href="/apply"
                  className="barlow-black"
                >
                  <Text as={'span'} color={"#4aeade"}>
                    <Lang text="HOW TO APPLY" />.
                  </Text>
                </Link>
              </Text>
            </Box>
          </Flex>
        </Box>
      </Center>

    </Box>
  );
}